import { render, staticRenderFns } from "./UrlParser.vue?vue&type=template&id=07b95148"
import script from "./UrlParser.vue?vue&type=script&lang=js"
export * from "./UrlParser.vue?vue&type=script&lang=js"
import style0 from "./UrlParser.vue?vue&type=style&index=0&id=07b95148&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports